export var WidgetActions;
(function (WidgetActions) {
    WidgetActions["list"] = "list";
    WidgetActions["register"] = "register";
    WidgetActions["detail"] = "details";
    WidgetActions["lookup"] = "lookup";
    WidgetActions["attendees"] = "attendees";
    WidgetActions["orders"] = "orders";
    WidgetActions["group"] = "group";
    WidgetActions["url"] = "url";
    WidgetActions["smart"] = "smart";
    WidgetActions["calendar"] = "calendar";
})(WidgetActions || (WidgetActions = {}));
